export const ENABLE_2FA = "ENABLE_2FA";
export const DISABLE_2FA = "DISABLE_2FA";
export const STATUS_2FA = "STATUS_2FA";
export const VALIDATE_QR = "VALIDATE_QR";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const SEND_PUSH = "SEND_PUSH";
export const GET_REMOTE_SESSION = "GET_REMOTE_SESSIONS";
export const SET_REMOTE_SESSION = "SET_REMOTE_SESSION";
export const SEND_CLINIC_INVITATION_EMAIL = "SEND_CLINIC_INVITATION";
